export default "__VITE_ASSET__V3yUzs5F__"